<template>
  <div class="das-form-container">
    <InfoList
      align-type="start"
      :columns="3"
      class="info-list__container-custom mt-0"
    >
      <InfoListLabel>Đặt phòng</InfoListLabel>
      <InfoListValue>{{ bookingDetailStore?.room_booking_code }}</InfoListValue>

      <InfoListLabel>Ngày đến</InfoListLabel>
      <InfoListValue>
        {{ getDateTimeFormatterWithoutSecond(bookingDetailStore.arrive_date) }}
      </InfoListValue>

      <InfoListLabel>Tổng tiền</InfoListLabel>
      <InfoListValue>
        {{
          `${$displayCurrency((+bookingDetailStore?.room_charge).toFixed(0))} ${
            bookingDetailStore?.currency_code
          }`
        }}
      </InfoListValue>

      <InfoListLabel>Tên người đặt</InfoListLabel>
      <InfoListValue>
        {{ bookingDetailStore.booker_name }}
      </InfoListValue>

      <InfoListLabel>Ngày đi</InfoListLabel>
      <InfoListValue>
        {{ getDateTimeFormatterWithoutSecond(bookingDetailStore.depart_date) }}
      </InfoListValue>

      <InfoListLabel>Số dư</InfoListLabel>
      <InfoListValue>
        {{ (+bookingDetailStore.room_balance).toLocaleString('en') }}
        {{ bookingDetailStore?.currency_code }}
      </InfoListValue>

      <InfoListLabel>Đoàn</InfoListLabel>
      <InfoListValue>
        {{ bookingDetailStore?.booking_group_code }}
      </InfoListValue>

      <!-- <InfoListLabel>Trạng thái</InfoListLabel>
      <InfoListValue>
        <template
          v-if="bookingDetailStore.status == BOOKING_ROOM_STATUS.DEFINITE"
        >
          Definite
        </template>
        <template
          v-else-if="bookingDetailStore.status == BOOKING_ROOM_STATUS.TENTATIVE"
        >
          Tentative
        </template>
        <template v-else>Waiting</template>
      </InfoListValue> -->

      <InfoListLabel>Trạng thái đặt phòng</InfoListLabel>
      <!-- <InfoListValue>
        <template
          v-if="
            bookingDetailStore.additional_info?.booking_status ==
            BOOKING_STATUS.DEFINITE
          "
        >
          Definite
        </template>
        <template
          v-else-if="
            bookingDetailStore.additional_info?.booking_status ==
            BOOKING_STATUS.TENTATIVE
          "
        >
          Tentative
        </template>
        <template v-else>Waiting</template>
      </InfoListValue> -->
      <InfoListValue>
        <template v-if="roomInfo.in_house"> Đang ở </template>
        <template v-else-if="roomInfo.depart"> Sẽ đi </template>
        <template v-else-if="roomInfo.arrive"> Sẽ đến </template>
        <template v-else>Đã đặt</template>
      </InfoListValue>
      <InfoListLabel>Nguồn</InfoListLabel>
      <InfoListValue>{{ bookingDetailStore.source_group_code }}</InfoListValue>
    </InfoList>
    <div class="das-form-input note-info">
      <div class="label">Ghi chú</div>
      <textarea
        :value="bookingDetailStore.note"
        readonly
        cols="30"
        rows="8"
      ></textarea>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { bookingDetailStore, roomInfo } from '../stores/'
import { BOOKING_STATUS, BOOKING_ROOM_STATUS } from '../constants'

export default {
  props: {},
  data() {
    return { bookingDetailStore, roomInfo }
  },
  computed: {
    BOOKING_STATUS() {
      return BOOKING_STATUS
    },
    BOOKING_ROOM_STATUS() {
      return BOOKING_ROOM_STATUS
    },
    currentPriceDetail() {
      const currentDateStr = new Date().toDateString()
      const prevDate = this.$moment()
        .subtract(1, 'days')
        .toDate()
        .toDateString()
      let prevDayPriceDetail = null
      let priceDetail = null

      this.bookingDetailStore?.daily_price?.find(item => {
        const tmpDate = this.$moment(item.date).toDate().toDateString()
        if (tmpDate === currentDateStr) {
          priceDetail = { ...item }
        } else if (tmpDate === prevDate) {
          prevDayPriceDetail = { ...item }
        }
      })

      return priceDetail ?? prevDayPriceDetail
    }
  },
  mounted() {},
  methods: {
    getDateTimeFormatterWithoutSecond(date) {
      return this.$moment(date).format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.info-list__container-custom {
  border: none;
  padding-bottom: 10px;
}

.note-info {
  .label {
    line-height: initial;
    padding-bottom: 10px;
  }

  textarea {
    width: 100%;
  }
}
</style>
